import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import MainContainer from './containers/MainContainer';
import DashboardContainer from './containers/dashboard/DashboardContainer';
import ReportsContainer from './containers/reports/ReportsContainer';
import UserGuideContainer from './containers/userguide/UserGuideContainer';
import ErrorsContainer from './containers/error/ErrorsContainer';
import RequestReportContainer from './containers/reports/RequestReportContainer';
import IncompatibleContainer from './containers/incompatible/IncompatibleContainer';
import LogoutContainer from './containers/logout/LogoutContainer';

/** Creating routing configuration */
const Routes = ({ location }) => (
  <Switch>
    <Route location={location} path="/incompatible" exact component={IncompatibleContainer} />
    <Route location={location} path="/logout" exact component={LogoutContainer} />
    <MainContainer location={location} path="/" exact component={DashboardContainer} />
    <MainContainer location={location} path="/home" exact component={DashboardContainer} />
    <MainContainer location={location} path="/reports" exact component={ReportsContainer} />
    <MainContainer location={location} path="/request-reports" exact component={RequestReportContainer} />
    <MainContainer location={location} path="/user-guide" exact component={UserGuideContainer} />
    <MainContainer location={location} path="*" exact component={ErrorsContainer} />
  </Switch>
);

/** Required function and props with the proptypes */
Routes.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default Routes;
